export enum AssetEventType {	
	CheckIn = 0,
	CheckOut = 10,
	Breakage = 20,
	Service = 30,
}